<template>
<section class="uk-section uk-animation-fade uk-margin-remove uk-padding-remove">
    <div class="uk-container-flex">
        <div class="uk-height-large uk-cover-container">
            <img src="images/IMG_20211218_113047.webp" alt="Alt img" data-uk-cover=""
                style="height: 500px; width: 1240px;">
            <div
                class="uk-overlay uk-overlay-primary uk-position-cover uk-flex uk-flex-center@m uk-flex-middle uk-text-center@m ">
                <div class="uk-scrollspy-inview uk-flex-center@m" data-uk-scrollspy="cls: uk-animation-slide-right-medium; target: > *; delay: 1000">
                    <img src="images/mbqm.png" width="100px">
                    <h1 class="uk-margin-top uk-margin-small-bottom uk-margin-remove-adjacent uk-text-italic">
                        Movimiento<br> Benito Quinquela Martín</h1>
                    <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit dolore magna aliqua.</p> -->
                    <a hrhref="#modal-contacto" uk-toggle class="uk-button uk-button-default uk-button-primary uk-margin-top">Conocenos 💙💛💙</a>
                    <div id="modal-contacto" uk-modal>
                        <div class="uk-modal-dialog uk-modal-body">
                            <h2 class="uk-modal-title">Tu mensaje</h2>
                            <form action="{{ route('enviarMsj') }}" method="POST" class="d-none">
                                @csrf
                                <div class="uk-width-1-2@s">
                                    <label class="uk-form-label" for="form-nombre-text">Nombre</label>
                                    <input class="uk-input @error('nombre') uk-form-danger @enderror" type="text" name="nombre" value="{{ old('nombre') }}">
                                    @error('nombre')
                                        <small class="uk-alert-danger">{{ $message }}</small>
                                    @enderror
                                </div>
                                <div class="uk-width-1-2@s">
                                    <label class="uk-form-label" for="form-apellido-text">Apellido</label>
                                    <input class="uk-input @error('apellido') uk-form-danger @enderror" type="text" name="apellido" value="{{ old('apellido') }}">
                                    @error('apellido')
                                        <small class="uk-alert-danger">{{ $message }}</small>
                                    @enderror
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="uk-container uk-width-3-4@m uk-flex-center uk-margin-auto uk-margin">
    <article class="uk-article uk-padding-remove-left">
        <div class="uk-card-body">
            <h2 class="uk-article-title  uk-padding-remove-left">Quienes Somos</h2>
            <p>El Movimiento Benito Quinquela Martín ha sido fundado el 3 de mayo de 2019, en una casa ubicada
                en la calle Necochea 1081 de la República de La Boca.</p>
            <p>Conformado en su mayoría por soci@s y vecin@s del barrio de La Boca fue creado para participar
                como movimiento político dentro de la actividad del Club Atlético Boca Juniors contando con el
                aval del actual Presidente Jorge Amor Ameal.</p>
            <p>Tiene como objeto promover la cultura y el desarrollo de las acciones sociales que beneficien tanto a los vecinos del barrio de La Boca, como así también a los socios Y SOCIAS DEL CLUB BOCA JUNIORS.</p>
            <p>Actualmente el Movimiento tiene una activa participación dentro del Club, colaborando en los Departamentos de Socios Y SOCIAS, Defensoría del Socio, Cultura, Relaciones Públicas, INTERIOR Y EXTERIOR, Prensa, Deportes Amateurs, FUNDACIÓN DEL CLUB ATLETICO BOCA JUNIORS, ETC.</p>
            <p>En LA REPUBLICA DE LA BOCA, PUEDEN ENCONTRARNOS EN NUESTRO LOCAL SITO EN BRANDSEN 653 EN EL HORARIO DE 16 A 21 TODOS LOS DIAS, A UNA CUADRA DE LA BOMBONERA</p>
            <p>Asimismo el Movimiento cuenta con el acompañamiento en sus filas DE SOCIOS Y SOCIAS DE LAS LOCALIDADES DE LANUS, MORENO, SAN JUSTO, SAN MARTIN, RAMOS MEJIA ENTRE OTROS.</p>
            <p>Es por lo expuesto, que sentimos una inmensa alegría y orgullo de pertenecer a esta gran familia
                Boquense y Xeneize y los invitamos a sumarse y a participar de nuestro espacio.</p>
        </div>
    </article>
    <article class="uk-section uk-section-default">
        <div>
            <div class="uk-section uk-section-small uk-padding-remove-top">
                <ul class="uk-subnav uk-subnav-pill uk-flex uk-flex-center" data-uk-switcher="connect: .uk-switcher; animation: uk-animation-fade">
                    <li><a class="uk-border-pill" href="#">Mision</a></li>
                    <li><a class="uk-border-pill" href="#">Vision</a></li>
                    <li><a class="uk-border-pill" href="#">Servicios</a></li>
                </ul>
            </div>

            <ul class="uk-switcher uk-margin">
                <li>
                    <div class="uk-grid uk-child-width-1-2@l uk-flex-middle" data-uk-grid data-uk-scrollspy="target: > div; cls: uk-animation-slide-left-medium">
                        <div  class="uk-padding-remove-left uk-flex uk-flex-around" >
                            <img src="/images/carnet_quinquela.webp" data-src="/images/mbqm.png" width="400px" data-uk-img>
                        </div>
                        <div data-uk-scrollspy-class="uk-animation-slide-right-medium">
                            <h6 class="uk-text-primary">Objectivo</h6>
                            <h2 class="uk-margin-small-top">El movimiento trabaja contantemente para:</h2>
                            <p class="subtitle-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation.
                            </p>
                            <div class="uk-grid uk-child-width-1-2@s" data-uk-grid>
                                <div>
                                    <h4>Fabián</h4>
                                    <p>El plus incondidicional del mov. se basa en que somos de la boca y sentimos el bario</p>
                                </div>
                                <div>
                                    <h4>Luisina</h4>
                                    <p>Constantemente estamos pensado en el barrio y es mejoar los aspectos referidos al club</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="uk-grid uk-child-width-1-2@l uk-flex-middle" data-uk-grid data-uk-scrollspy="target: > div; cls: uk-animation-slide-left-medium">
                        <div class="uk-padding-remove-left uk-flex uk-flex-around" >
                            <img src="/images/logotipo.webp" data-src="/images/logotipo.webp"  width="300px" alt="" data-uk-img>
                        </div>
                        <div data-uk-scrollspy-class="uk-animation-slide-right-medium">
                            <h6 class="uk-text-primary">Objetivo</h6>
                            <h2 class="uk-margin-small-top">Take decisions with real time data based on users interaction.</h2>
                            <p class="subtitle-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation.
                            </p>
                            <div class="uk-grid uk-child-width-1-2@s" data-uk-grid>
                                <div>
                                    <h4>Great stuff</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud magna aliqua exercitation. <a href="">Learn more.</a></p>
                                </div>
                                <div>
                                    <h4>Data analysis</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud magna aliqua exercitation. <a href="">Learn more.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="uk-grid uk-child-width-1-2@l uk-flex-middle" data-uk-grid data-uk-scrollspy="target: > div; cls: uk-animation-slide-left-medium">
                        <div class="uk-padding-remove-left uk-flex uk-flex-around" >
                            <img src="/images/mbqm.png" data-src="/images/carnet_quinquela.webp"   width="300px" alt="" data-uk-img>
                        </div>
                        <div data-uk-scrollspy-class="uk-animation-slide-right-medium">
                            <h6 class="uk-text-primary">servicios</h6>
                            <h2 class="uk-margin-small-top">Take decisions with real time data based on users interaction.</h2>
                            <p class="subtitle-text">
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                                tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                                quis nostrud exercitation.
                            </p>
                            <div class="uk-grid uk-child-width-1-2@s" data-uk-grid>
                                <div>
                                    <h4>Great stuff</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud magna aliqua exercitation. <a href="">Learn more.</a></p>
                                </div>
                                <div>
                                    <h4>Data analysis</h4>
                                    <p>Ut enim ad minim veniam, quis nostrud magna aliqua exercitation. <a href="">Learn more.</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </article>
</section>
<!-- Auspiciantes -->
<!-- <div class="uk-section uk-section-small uk-section-muted">
    <div class="uk-container uk-container-small">
        <div class="uk-grid uk-child-width-1-4 uk-child-width-expand@m logos-grid" data-uk-grid data-uk-scrollspy="cls: uk-animation-scale-down; target: > div > img; delay: 100">
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp"  data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp" data-uk-img alt="Image">
            </div>
            <div>
                <img src="/images/logotipo.webp" data-src="/images/logotipo.webp">
            </div>
        </div>
    </div>
</div> -->
</template>